import { Metadata } from 'next';
import VerifyOTP from '@/Component/Auth/VerifyOTP'

export const metadata: Metadata = {
    title: "Verify OTP | Connector Club",
    description: "",
};

const VerifyOTPPage = () => {
  return (
    <VerifyOTP />
  )
}

export default VerifyOTPPage
